import * as React from "react";
import { forwardRef } from "react";
const SvgSortDesc = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 800, height: 800, fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "rgba(255,255,255,0.5)", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M7 3v18m0 0-4-4m4 4 4-4m3-14h7m-7 6h5m-5 6h3m-3 6h1" }));
const ForwardRef = forwardRef(SvgSortDesc);
export { ForwardRef as ReactComponent };
